<template>
  <div id="player">
    <player :link="link" :ts="ts" :lite="lite" />
  </div>
</template>

<script>
import Loader from "./components/Loader";

export default {
  components: {
    Player: () => ({
      component: import("./components/Player"),
      loading: Loader,
    }),
  },
  computed: {
    link() {
      if (process.env.NODE_ENV === "development") {
        // return "https://api.zencast.fm/embed/episode/c69cb301-d606-4d26-92dc-1a1a501b063e";
        // return "https://api.zencast.fm/api/embed/podcast/1283f239-52d1-437b-9781-64d4f757ee4c";
        // return "https://api.zencast.fm/api/embed/podcast/1283f239-52d1-437b-9781-64d4f757ee4c/latest";
        // return "https://api.zencast.fm/api/embed/episode/14e14dc9-8f05-4778-a570-0b42e7035441";
        return window.location.href;
      } else {
        return window.location.href;
      }
    },

    lite() {
      const lite = new URL(window.location.href).searchParams.get("lite");
      return lite ? true : false;
    },

    ts() {
      const ts = new URL(window.location.href).searchParams.get("ts");
      return ts ? parseInt(ts) : null;
    },
  },
};
</script>

<style lang="scss">
:root {
  --primary-color: #393939;
  --secondary-color: #fafafa;
  --text-color: #262626;
}

body {
  margin: 0;
}

.badge {
  display: inline-block;
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  border-color: var(--text-color);
  padding: 1px 7px;
  font-size: 12px;
  margin-left: 3px;
  margin-right: 6px;
}

.pale {
  opacity: 0.5;
}
</style>
